module.exports = __webpack_public_path__ + "fonts/Inter-700-latin70.8e433c0.woff2";